import type { ReactNode } from "react";

export default function EmptyState({
  icon,
  title,
  message,
  action,
}: {
  icon?: ReactNode;
  title: string;
  message?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-8 px-4">
      {icon && (
        <div className="text-fg-subtle/60 mb-3" aria-hidden>
          {icon}
        </div>
      )}
      <div className="text-sm font-medium text-fg">{title}</div>
      {message && <div className="mt-1 text-sm text-muted max-w-md">{message}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
